import React, { createContext, useEffect, useState } from "react";
import { message } from "antd";
import {
  QueryClientProvider,
  QueryClient,
  QueryCache,
  MutationCache,
} from "react-query";
import { AuthContextProvider } from "../context/authContext";
import App from ".";
import { UploadProvider } from "../context/uploadFileContext";
  import { UploadProvider as SeggUploadProvider } from "../context/seggUploadFileContext";
import SeggregationProvider from "../context/seggregationProvider";
import BatchProvider from "../context/batchProvider";
import GuidelinesProvider from "../context/guidelinesProvider";
import UserWalletContextProvider from "../context/userWalletContext";
import SourceProvider from "../context/sourceProvider";

const AppInitializer = () => {
  const logoutHandler = () => {
    localStorage.removeItem("flowedit:user");
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
  };
  const queryError = (error) => {
    if (error?.response?.status === 401) {
      message.error("Unauthorized");
      logoutHandler();
    }
  };

  // const queryClient = new QueryClient({
  //   queryCache: new QueryCache({ onError: queryError }),
  //   mutationCache: new MutationCache({ onError: queryError }),
  // });
  const queryClient = new QueryClient({
    queryCache: new QueryCache({ onError: queryError }),
    mutationCache: new MutationCache({ onError: queryError }),
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => {
          if (error?.response?.status === 401) {
            return false;
          }
          return failureCount < 3;
        },
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <SourceProvider>
        <UserWalletContextProvider>
          <AuthContextProvider>
            <UploadProvider>
              <SeggUploadProvider>
                <GuidelinesProvider>
                  <BatchProvider>
                    <SeggregationProvider>
                      <App />
                    </SeggregationProvider>
                  </BatchProvider>
                </GuidelinesProvider>
              </SeggUploadProvider>
            </UploadProvider>
          </AuthContextProvider>
        </UserWalletContextProvider>
      </SourceProvider>
    </QueryClientProvider>
  );
};

export default AppInitializer;
